import React from "react";
import { Panel } from "@/components";
import NewFeatures from "./NewFeatures";
import RecommendFeatures from "./RecommendFeatures";

interface FeaturesCardProps {}

const FeaturesCard: React.FC<FeaturesCardProps> = function (props) {
    return (
        <>
            <Panel title="新功能" className="mb20">
                <NewFeatures />
            </Panel>

            <Panel title="推荐功能" className="mb20">
                <RecommendFeatures />
            </Panel>
        </>
    );
};

export default React.memo(FeaturesCard);
